import React from 'react';

import usStateGeoJSONData from './geo-data/usStateMapCoordinates';
import MapDefault from './map-default';

const MapState = (props) => {
	return <MapDefault {...props} />;
};

MapState.propTypes = MapDefault.propTypes;

MapState.defaultProps = {
	geoJSONData: usStateGeoJSONData,
};

export default MapState;
